const GROWER_PREFIX = "grower:";
const JOB_PREFIX = "job:";

export type DraggableType = "grower" | "job";

export interface ParsedDraggableId {
	type: DraggableType;
	key: string;
}

export function makeGrowerDraggableId(growerName: string): string {
	return GROWER_PREFIX + growerName;
}

export function makeJobDraggableId(jobId: string): string {
	return JOB_PREFIX + jobId;
}

export function parseDraggableId(id: string): ParsedDraggableId {
	if (id.startsWith(GROWER_PREFIX)) {
		return { type: "grower", key: id.slice(GROWER_PREFIX.length) };
	}
	if (id.startsWith(JOB_PREFIX)) {
		return { type: "job", key: id.slice(JOB_PREFIX.length) };
	}
	// Fallback: treat as grower for backward compatibility
	return { type: "grower", key: id };
}

export function isGrowerDraggable(id: string): boolean {
	return id.startsWith(GROWER_PREFIX);
}
